import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {Store} from '@ngxs/store';
import {AuthState} from '@shared/store/auth/auth.state';

@Injectable({
  providedIn: 'root'
})
export class IsExternalLoginGuard  {
  constructor(
    private store: Store,
    private router: Router,
  ) {}

  canActivate(): boolean {
    return this.checkLogin();
  }

  canActivateChild(): boolean {
    return this.checkLogin();
  }

  canLoad(): boolean {
    return this.checkLogin();
  }

  private checkLogin(): boolean {
    if (this.store.selectSnapshot(AuthState.authenticated)) {

      // this.router.navigateByUrl('/');
      // this.router.navigateByUrl('/app/schooling?isExternalInvitation=true');
      // this.router.navigateByUrl('/external/invitation/externalEmployee');

      return false;
    }

    return true;
  }
}
